export default __webpack_public_path__ + "static/media/last.96b89f50.png";